// section-related-products.js
(function(){
  'use strict';
  var $ = function(sel, root){ return (root || document).querySelector(sel); };
  var $$ = function(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var debounce = function(fn, wait){ var t; return function(){ clearTimeout(t); t = setTimeout(fn.bind(this, ...arguments), wait||80); }; };

  function readGap(grid){
    var cs = getComputedStyle(grid);
    var g = parseFloat(cs.gap || cs.columnGap || 20);
    return isNaN(g) ? 20 : g;
  }

  function updateOneGrid(grid){
    if (!grid) return;
    var items = $$('.grid__item', grid);
    if (!items.length) { grid.classList.remove('related--horizontal'); return; }

    // Desktop: paksa horizontal jika item > 4, mobile: horizontal default
    if (items.length > 4 || window.innerWidth < 989) {
      grid.classList.add('related--horizontal'); return;
    }

    // Cek apakah 4 kolom muat; jika tidak, jadikan horizontal
    var gap = readGap(grid);
    var w = (items[0].getBoundingClientRect().width || 0);
    var required = (w * 4) + (gap * 3);
    if (grid.clientWidth + 1 < required) grid.classList.add('related--horizontal');
    else grid.classList.remove('related--horizontal');
  }

  function updateAll(){
    $$('.related-products .product-grid').forEach(updateOneGrid);
  }
  var onResize = debounce(updateAll, 120);

  function scrollGridByItems(grid, count){
    var items = $$('.grid__item', grid);
    if (!items.length) return;
    var gap = readGap(grid);
    var w = items[0].getBoundingClientRect().width;
    var delta = (w + gap) * Math.abs(count);
    grid.scrollBy({ left: count < 0 ? -delta : delta, behavior: 'smooth' });
  }

  document.addEventListener('DOMContentLoaded', function(){
    updateAll();
    window.addEventListener('resize', onResize, { passive: true });

    // Observe perubahan DOM agar layout tetap akurat
    if (window.MutationObserver) {
      $$('.related-products').forEach(function(container){
        var mo = new MutationObserver(onResize);
        mo.observe(container, { childList:true, subtree:true, attributes:true });
      });
    }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onResize);
      $$('.related-products .product-grid, .related-products .grid__item').forEach(function(el){
        try { ro.observe(el); } catch(e){}
      });
    }

    // Hubungkan tombol prev/next di HEADER ala Best Sellers
    $$('.related-products').forEach(function(container){
      var grid = $('.product-grid', container);
      if (!grid) return;

      var prev = $('.related-products__actions .swiper-button-prev', container);
      var next = $('.related-products__actions .swiper-button-next', container);

      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); scrollGridByItems(grid, -1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); scrollGridByItems(grid, 1); });

      // Sembunyikan panah jika item sedikit (≤ 4)
      var items = $$('.grid__item', grid);
      var many = items.length > 4;
      if (prev) prev.style.display = many ? '' : 'none';
      if (next) next.style.display = many ? '' : 'none';
    });
  });
})();
